import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getEaccountingStatus = (token: string, backend: string) => {
    return fetch(`${getApiUrl(backend)}visma_eaccounting_status`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getEaccountingStatus